/** Public cart mutation bounds shared by every cart route and the UI. */
export const CART_LINE_QUANTITY_MAX = 100;
export const CART_LINES_MAX = 20;
export const CART_ATTRIBUTES_MAX = 20;
export const CART_ATTRIBUTE_KEY_MAX = 64;
export const CART_ATTRIBUTE_VALUE_MAX = 2048;
export const CART_ID_MAX = 255;

// Shopify IDs are opaque values. Keep validation intentionally format-neutral
// because cart IDs may include an encoded key, but reject control characters so
// they cannot become log/header injection payloads.
export const opaqueCartId = (max = CART_ID_MAX) =>
  new RegExp(`^[^\\u0000-\\u001F\\u007F]{1,${max}}$`);
